module.exports = __webpack_public_path__ + "img/chainE04.71b75624.png";